export const BULK_WRITES_REDUCER_KEY = 'bulkWritesStore';
export type BULK_WRITES_REDUCER_KEY = typeof BULK_WRITES_REDUCER_KEY;

/** A resource write large enough that it was split into more than one request. */
export type BulkWrite = {
  id: string;
  resourceName: string;
  total: number;
  /** Resources whose request has been sent, including the one still in flight. */
  submitted: number;
  /**
   * Set once the write has failed, which keeps the entry around so the failure can be surfaced
   * rather than the operation just disappearing. `committed` counts only the requests that
   * completed, so it is a floor: the request that failed may itself have written some of its own
   * resources before erroring. `retryQueued` means the action went to the retry queue instead of
   * failing outright — nothing retries it automatically, so it still needs reporting.
   */
  failure?: { committed: number; retryQueued: boolean };
};

export type BulkWritesStore = {
  operations: Record<string, BulkWrite>;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [BULK_WRITES_REDUCER_KEY]: BulkWritesStore;
  }
}
